import { Item } from "@/models/Item"
import { $t } from "@/plugins/i18n"
import { getInitials as getInitialsHelper, replaceHtmlTagsV2 } from "@/utils/helpers"

import { NotificationItem } from "./NotificationItem"

export class NotificationItemDeleted extends NotificationItem {
  constructor(props) {
    super(props)
  }

  get deletedItem() {
    return this.content?.item || this.content?.deletedItem
  }

  get initiator() {
    return this.content?.initiator ?? this.content?.initiators?.[0]
  }

  get initiatorAvatarSrc() {
    return this.initiator?.picture?.pictureUrl
  }

  get initiatorFullName() {
    const initiator = this.initiator
    if (!initiator) return ""
    return initiator.firstName + " " + initiator.lastName
  }

  getInitials() {
    return getInitialsHelper(this.initiatorFullName)
  }

  get itemSequenceNumber() {
    return `#${this.deletedItem?.sequenceNumber ?? $t("none")}`
  }

  get deletionReason() {
    const rawContent = this.content?.deletionReason ?? ""
    return replaceHtmlTagsV2(rawContent)
  }

  get deletedLocation(): string {
    const deletedItem = this.deletedItem
    if (!deletedItem) return ""

    const item = Item.create(deletedItem)
    const backlogKey = Item.getBacklogTypeByItem(item)
    const itemType = deletedItem.itemType ?? item.itemTypeParsed?.id

    const isInSprint = backlogKey === "backlogSprint" || !!deletedItem.sprintSequenceNumber
    if (isInSprint) {
      return "Active Sprint"
    }

    if (backlogKey === "backlogUnprioritized") {
      return "Unprioritized Backlog"
    }

    if (itemType) {
      return $t(`backlog.titlesByItemTypeFull['${itemType.toLowerCase()}']`)
    }

    return Item.getBacklogNameByItem(item, true)
  }
}
